import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import { formatMnDate } from "@mnjsplatform/data/lib/utils/formatData";
import formatData from "@mnjsplatform/data/lib/utils/formatData";
import SubgridPlaceholder from "@mnjsplatform/components/lib/common/Subgrid/SubgridPlaceholder"
import { initSubgrid, unmountSubgrid } from "@mnjsplatform/data/lib/actions/subgridActions";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import DropDownMenuComboLink from "@mnjsplatform/components/lib/common/DropdownMenu/DropDownMenuComboLink";
import DocumentStatusImage from "@mnjsplatform/components/lib/common/DocumentStatusImage";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import { formObjectToRouteMap } from "../Navigation/Routes";
import { Link } from "react-router-dom";
import queryString from "query-string";
import {withRouter} from 'react-router';
import {buildReport} from "@mnjsplatform/data/lib/actions/reportActions";
import ReportBuildViewer from "@mnjsplatform/components/lib/common/Reports/ReportBuildViewer";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import {auctionBidModes, workplaceCountries} from "../../actions/AppActions";

class AuctionList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isLoading: true,
      expandedRows: {},
      updateGridFlag: null,
      subGridExpandState: {},
      subGridKeys: {},
      newAuctionCount: 0,
      newTransportRequestCount: 0,
      routeDetailsWindowOpened: false
    };

    this.refreshTimerId = null;
    this.refreshTimerStopped = false;
    this.countdownTimerId = null;
    this.informerTimerId = null;
    this.afterRefreshSeconds = 0;

    this.auctionFieldSet = props.auctionBidMode === auctionBidModes.lot
      ? {
        currentBid: "CurrentCostLoad",
        step: "TenderStepMoney",
        bidEditor: "VCostLoad",
        bonusPriceSrc: "BonusCostLoad",
        bonusPriceDst: "CostLoad"
      }
      : {
        currentBid: "CurrentPrice",
        step: "TenderStepMoney",
        bidEditor: "VPrice",
        bonusPriceSrc: "BonusPrice",
        bonusPriceDst: "Price"
      };
  }

  componentDidMount() {
    this.setState({isLoading: true});

    this.refreshInformer();

    const execParams = this.getExecParamsFromQueryString(this.props.location);

    this.props.dispatch(this.props.auctionList.execute(execParams, {withParams: true, persistParamSet: false}))
      .then(() => this.refreshAuctionStakes())
      .finally(() => {
        this.onUpdateCountdownTimer();
        this.setState({isLoading: false})
      });
  }

  componentWillUpdate(nextProps, nextState, nextContext) {

    if(nextProps.location.search && this.props.location.search !== nextProps.location.search) {
      const params = queryString.parse(nextProps.location.search);

      if(params["ShowOnlyNew"] != null) {
        this.onRefreshFormClick(nextProps.location);
      }

    }
  }

  componentWillUnmount() {

    if(this.refreshTimerId != null) {
      clearTimeout(this.refreshTimerId);
      this.refreshTimerStopped = true;
      this.refreshTimerId = null;
    }

    if(this.countdownTimerId != null) {
      clearTimeout(this.countdownTimerId);
      this.countdownTimerId = null;
    }

    if(this.informerTimerId != null) {
      clearTimeout(this.informerTimerId);
      this.informerTimerId = null;
    }

    this.resetAllSubgrids(false);
  };

  resetAllSubgrids = (updateState = true) => {
    Object.values(this.state.subGridKeys).forEach((value) => {
      this.props.dispatch(unmountSubgrid(this.props.auctionList, value));
    });

    if(updateState)
      this.setState({ subGridKeys: {}, subGridExpandState: {}});
  };

  onExportToExcelButtonClick = (row, rowIndex) => {
    const reportId = "YMWEBListlot";

    this.props.dispatch(buildReport(reportId, this.props.auctionListParams.getRow(0)));
  };

  onRefreshFormClick = (location) => {

    this.setState({isLoading: true});

    this.resetAllSubgrids();

    let execParams = {};

    if(location)
      execParams = this.getExecParamsFromQueryString(location);

    this.props.dispatch(this.props.auctionList.execute(execParams, {withParams: true}))
      .then(() => {

        this.clearRefreshStakesTimeout()

        if(this.informerTimerId != null) {
          clearTimeout(this.informerTimerId);
          this.informerTimerId = null;
        }

        this.refreshInformer();
        this.refreshAuctionStakes()
      })
      .finally(() => {
        this.setState({isLoading: false})
      });
  };

  getExecParamsFromQueryString(location) {

    if(!location)
      return {};

    const queryParams = queryString.parse(location.search);
    let newQueryParams = {};
    const execParams = {};
    if(queryParams["ShowOnlyNew"] != null) {
      execParams["ShowOnlyNew"] = queryParams["ShowOnlyNew"];

      let hasParams = false;

      Object.keys(queryParams).forEach((key) => {
        if(key !== "ShowOnlyNew") {
          hasParams = true;
          newQueryParams[key] = queryParams[key];
        }
      });

      if(hasParams) {
        let path = location.pathname + '?' + queryString.stringify(newQueryParams);
        this.props.history.replace(path);
      }
      else
        this.props.history.replace(location.pathname);
    }

    return execParams;
  }

  refreshInformer = () => {
    this.informerTimerId = null;

    this.props.dispatch(this.props.auctionInformerItem.execute())
      .then(data => {

        let auctionCount = 0;
        let transportReqCount = 0;

        this.props.auctionInformerItem.dataTable().forEach((row, rowIndex) => {

          if(row.Document_Object === "TenderDocumentRels")
              auctionCount = row.CountNew == null ? 0 : row.CountNew;
          else if(row.Document_Object === "PickupList")
              transportReqCount = row.CountNew == null ? 0 : row.CountNew;
        });

        /*auctionCount = this.state.newAuctionCount + 1;
        transportReqCount = this.state.newTransportRequestCount + 1;*/

        this.informerTimerId = setTimeout(this.refreshInformer, 5*60*1000);
        this.setState({newAuctionCount: auctionCount, newTransportRequestCount: transportReqCount});
      });
  };

  getTenderDocumentRelsListXML = (activeAuctionList) => {
    return "<TenderDocumentRelsList>"
      + activeAuctionList.map(e => `<item id1="${e.id1}" id2="${e.id2}" />`).join('')
      + "</TenderDocumentRelsList>";
  };

  refreshAuctionStakes = () => {

    if(this.refreshTimerStopped)
      return;

    this.clearRefreshStakesTimeout();

    if (!this.props.auctionList.isInitialized) {
      this.setRefreshStakesTimeout();
      return;
    }

    let activeAuctionList = [];

    this.props.auctionList.dataTable().forEach((row, rowIndex) => {
      //if (row.AllowStake === 1)
        activeAuctionList.push({ id1: row.TenderDocumentIntId, id2: row.PickupListIntId });
    });

    if (activeAuctionList.length === 0) {
      this.setRefreshStakesTimeout();
      return;
    }

    let params = {
      TenderDocumentRelsList: this.props.workplaceCountry === workplaceCountries.UKR
        ? this.getTenderDocumentRelsListXML(activeAuctionList)
        : JSON.stringify(activeAuctionList)
    };

    this.props.dispatch(this.props.auctionStakesRefresh.execute(params, {dataOnly: true}))
      .then((data) => {

        this.setRefreshStakesTimeout();

        if(!this.props.auctionStakesRefresh.isInitialized)
          return;

        let newTable = Object.assign([], this.props.auctionList.rawData.DataTable);

        this.props.auctionStakesRefresh.dataTable().forEach((row, rowIndex) => {
          let rowKey = this.props.auctionStakesRefresh.getRowKey(row);
          let dstRowIndex = this.props.auctionList.getRowIndex(rowKey);

          if (dstRowIndex >= 0) {

            let newRow = Object.assign({}, newTable[dstRowIndex]);

            for (let name in row) {
              if (!row.hasOwnProperty(name))
                continue;

              if(name !== "CostLoad")
                newRow[name] = row[name];
              else {
                let oldCostLoad = newRow["CostLoad"];

                if(!oldCostLoad)
                  oldCostLoad = 0;

                let maxCostLoad = row.IsFirstStake === 1 ? row.MaxCostLoad : row.CostLoad;

                if(/*oldCostLoad < row.MinCostLoad || */oldCostLoad > maxCostLoad)
                  newRow["CostLoad"] = row["CostLoad"];
              }

              newTable[dstRowIndex] = newRow;
            }
          }
        });

        this.afterRefreshSeconds = 0;
        let newRawData = Object.assign({}, this.props.auctionList.rawData, {DataTable: newTable});

        this.props.dispatch(this.props.auctionList.refreshDataSuccess(newRawData));
      })
      .finally(() => {
          this.setState({ updateGridFlag: Date.now()
        })
      })
  };

  setRefreshStakesTimeout = () => {
    this.refreshTimerId = setTimeout(this.refreshAuctionStakes, 10000);
  };

  clearRefreshStakesTimeout = () => {
    if(this.refreshTimerId != null) {
      clearTimeout(this.refreshTimerId);
      this.refreshTimerId = null;
    }
  };

  onUpdateCountdownTimer = () => {
    this.afterRefreshSeconds += 1;
    this.setState({ updateGridFlag: Date.now()});

    this.countdownTimerId = setTimeout(this.onUpdateCountdownTimer, 1000);
  };

  onRowToggle = (rowIndex) => {
    let isExpanded = !!this.state.expandedRows[rowIndex];
    let expandedRows = this.state.expandedRows;
    expandedRows[rowIndex] = !isExpanded;
    this.setState({expandedRows: expandedRows, updateGridFlag: Date.now()});
  };

  onShowRouteDetails = (rowIndex) => {

    this.setState({routeDetailsWindowOpened: true});

    let params = {IsOnlyTotal: 0};

    Object.assign(params, this.props.auctionList.getRow(rowIndex));

    this.props.dispatch(this.props.routeDetailsItem.reset())
      .then(() => {this.props.dispatch(this.props.routeDetailsItem.execute(params, {newItem: true}))});
  };

  onCloseRouteDetails = () => {
    this.setState({routeDetailsWindowOpened: false});
  };

  onShowSubGrid = (rowIndex) => {
    let isExpanded = !!this.state.subGridExpandState[rowIndex];
    let subGridExpandState = this.state.subGridExpandState;
    subGridExpandState[rowIndex] = !isExpanded;

    this.setState({ subGridExpandState: subGridExpandState, updateGridFlag: Date.now() });

    if(isExpanded)
      this.closeSubgrid(rowIndex);
    else
      this.initRouteSubgrid(rowIndex);
  };

  initRouteSubgrid = (rowIndex) => {
    this.props.dispatch(initSubgrid(this.props.auctionList, "CityRouteGrid", rowIndex, "", true))
      .then(key => {
        let subGridKeys = this.state.subGridKeys;
        subGridKeys[rowIndex] = key;
        this.setState({ subGridKeys: subGridKeys, updateGridFlag: Date.now() });
      });
  };

  closeSubgrid = (rowIndex) => {
    this.props.dispatch(unmountSubgrid(this.props.auctionList, this.state.subGridKeys[rowIndex]))
      .then(() => {
        let subGridKeys = this.state.subGridKeys;
        subGridKeys[rowIndex] = null;
        this.setState({ subGridKeys: subGridKeys, updateGridFlag: Date.now()
        });
      });
  };

  onAcceptButtonClick = (row, rowIndex) => {

    confirm(i18next.t("ConfirmParticipationInLot"))
      .then(() => {this.props.dispatch(this.props.auctionAcceptItem.initialize(row, {newItem: true}))})
      .then(()=> {this.props.dispatch(this.props.auctionList.refresh())})
      .then(()=> {this.refreshInformer()});
  };

  onRefuseButtonClick = (row, rowIndex) => {
    confirm(i18next.t("RefuseToParticipateInLot"))
      .then(() => {this.props.dispatch(this.props.auctionRefuseItem.initialize(row, {newItem: true}))})
      .then(()=> {this.props.dispatch(this.props.auctionList.refresh())})
      .then(()=> {this.refreshInformer()});
  };

  onPrintReportButtonClick = (row, rowIndex) => {
    const reportId = "ForvarderReques";
    //const params = this.props.row;

    this.props.dispatch(buildReport(reportId, row))
  };

  onBeforeApplyFormParams = () => {
    this.resetAllSubgrids();
  };

  sortSelected = (menuItem) => {
    this.props.dispatch(this.props.auctionList.sortRows(menuItem.MenuItemId, menuItem.SortIsAsc))
  };

  sortClear = () => {
    this.props.dispatch(this.props.auctionList.clearSort())
  };

  renderRouteDetailsWindow = () => {
    if(!this.state.routeDetailsWindowOpened)
      return null;

    return (
      <PopupWrapper onClose={this.onCloseRouteDetails} popupVisible={this.state.routeDetailsWindowOpened} title={i18next.t("InfoAboutLinkedDocuments")}>
        <GridView dataItem={this.props.routeDetailsItem} readOnly/>
      </PopupWrapper>
    );
  };

  renderRouteSubgridRow = (row, rowIndex, renderRowDefault, dataItem) => {

    let fiMap = {};

    dataItem.rawData.ResultFieldInfo.forEach((item) => {fiMap[item.Name] = item;});

    let loadOrder = formatData(fiMap["LoadOrder"], row.LoadOrder);

    if(loadOrder)
      loadOrder += ". ";
    else
      loadOrder = "";

    let clientName = formatData(fiMap["Receiver"], row.Receiver);

    let weight = formatData(fiMap["Weight"], row.Weight);

    if(weight && weight.length > 0)
      weight = "    " + fiMap.Weight.Title + ": " + weight;
    else
      weight = "";

    let deliveryPeriod = null;
    const isUkr = this.props.workplaceCountry === workplaceCountries.UKR;

    if(row.DTOrderDay || row.DTOrderTimeMin || row.DTOrderTimeMax)
      deliveryPeriod = i18next.t(`TransportReqCard_DeliveryPeriod${isUkr ? "_Ukr" : ""}`, {
        date: row.DTOrderDay != null ? formatMnDate(row.DTOrderDay) + " " : "",
        minTime: formatMnDate(row.DTOrderTimeMin),
        maxTime: formatMnDate(row.DTOrderTimeMax)
      });

    return (
      <React.Fragment>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px", marginTop: "1px"}}>
            <span style={{color: "white"}}>{loadOrder}{clientName}</span>
            <span style={{ color: "white", marginLeft: "5px", fontWeight: "bold" }}>{weight}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green"}}>
            <span style={{color: "white"}}>{row.DstPointName}</span>
          </div>
        </div>
        {deliveryPeriod &&
        <div className="row fs15">
          <div className="column col-md-12" style={{ backgroundColor: "green" }}>
            <span style={{ color: "white" }}>{deliveryPeriod}</span>
          </div>
        </div>
        }
      </React.Fragment>
    );

    /*let deliveryPeriod = (row.DTOrderDay != null ? formatMnDate(row.DTOrderDay) : "") + " с " + formatMnDate(row.DTOrderTimeMin) + " до " + formatMnDate(row.DTOrderTimeMax);
    let documentDescription = row.DocumentNumber + " от " + formatMnDate(row.DocumentDate);

    let fiMap = {};

    dataItem.rawData.ResultFieldInfo.forEach((item) => {fiMap[item.Name] = item;});

    return (
      <React.Fragment>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px", marginTop: "1px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Тип документа:</span>
            <span style={{color: "white"}}>&nbsp;{row.DocumentTypeName}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Номер документа:</span>
            <span style={{color: "white"}}>&nbsp;{documentDescription}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-6" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Вес:</span>
            <span style={{color: "white"}}>&nbsp;{formatData(fiMap["Weight"], row.Weight)}</span>
          </div>
          <div className="column col-md-6" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Сумма:</span>
            <span style={{color: "white"}}>&nbsp;{formatData(fiMap["GrossCost"], row.GrossCost)}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Пункт отправки:</span>
            <span style={{color: "white"}}>&nbsp;{row.SrcPointName}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Пункт доставки:</span>
            <span style={{color: "white"}}>&nbsp;{row.DstPointName}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Грузополучатель:</span>
            <span style={{color: "white"}}>&nbsp;{row.Receiver}</span>
          </div>
        </div>
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
            <span className="field-title fs13" style={{color: "white"}}>Плановая доставка:</span>
            <span style={{color: "white"}}>&nbsp;{deliveryPeriod}</span>
          </div>
        </div>
      </React.Fragment>
    );*/
  };

  renderRouteSubgrid = (rowIndex) => {

    if(!this.state.subGridKeys[rowIndex])
      return (
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", textAlign: "center", paddingTop: "15px", paddingBottom: "15px"}}>
            <span style={{color: "white"}}>{i18next.t("LoadingLabel")}</span>
          </div>
        </div>
      );

    return (
      <SubgridPlaceholder subgridKey={this.state.subGridKeys[rowIndex]}>
        {(subgridItem) => {

          if(subgridItem.rowsCount() === 0)
            return (
              <div className="row fs15">
                <div className="column col-md-12" style={{backgroundColor: "green", textAlign: "center", paddingTop: "15px", paddingBottom: "15px"}}>
                  <span style={{color: "white"}}>{i18next.t("GridViewEmptyLabel")}</span>
                </div>
              </div>
            );
          else
            return (
              <GridView dataItem={subgridItem}
                        readOnly
                        renderRow={this.renderRouteSubgridRow}
                        showHeader={false}
                        allowHorizontalScrolling={false}
              />
            );
        }
        }
      </SubgridPlaceholder>
    );
  };

  renderParams = (h) => {

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-4">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("InterCompanySetName")}
            </div>
            <div>
              {h.ed("InterCompanySetName")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("BeginDate")}
            </div>
            <div>
              {h.ed("BeginDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("EndDate")}
            </div>
            <div>
              {h.ed("EndDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("FilterType")}
            </div>
            <div>
              {h.ed("FilterType")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("SrcCitySetName")}
            </div>
            <div>
              {h.ed("SrcCitySetName")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("MoveDate")}
            </div>
            <div>
              {h.ed("MoveDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("DstCitySetName")}
            </div>
            <div>
              {h.ed("DstCitySetName")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("DeliveryAddressTreeSetName")}
            </div>
            <div>
              {h.ed("DeliveryAddressTreeSetName")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-7">
            <div className="field-title" style={{textAlign: "left"}}>
              {i18next.t("SearchLabel")}
            </div>
            <SearchBar dataItem={this.props.auctionList}/>
          </div>
          <div className="col-md-5">
            <div className="field-title" style={{textAlign: "left"}}>
              &nbsp;
            </div>
            {this.renderSortMenu()}
          </div>
        </div>
      </React.Fragment>)
  };

  onChangeBidByStep = (stepValue, dataRow) => {
      let newBid = dataRow.CostLoad + stepValue;

      if(newBid < dataRow.MinCostLoad)
        newBid = dataRow.MinCostLoad;
      else if(newBid > dataRow.MaxCostLoad)
        newBid = dataRow.MaxCostLoad;

      let rowIndex = this.props.auctionList.getRowIndex(dataRow);

      if(rowIndex >= 0)
        this.props.dispatch(this.props.auctionList.setFields(rowIndex, {CostLoad: newBid, ROCostLoad: newBid}));
          //.then(() => this.setState({updateGridFlag: Date.now()}))
  };

  onConfirmBidButtonClick = (row, rowIndex) => {
      this.props.dispatch(this.props.auctionList.save(rowIndex))
          .then(() => {this.clearRefreshStakesTimeout();
                       this.refreshAuctionStakes();})
  };

  onConfirmPrizeTariffButtonClick = (row, rowIndex) => {
    confirm(i18next.t("ConfirmPrizeTariffText"))
      .then(async() => {
        const bonusCostLoad = this.props.auctionList.getField(rowIndex, this.auctionFieldSet.bonusPriceSrc);
        await this.props.dispatch(this.props.auctionList.setFields(rowIndex, {[this.auctionFieldSet.bonusPriceDst]: bonusCostLoad}));
        await this.onConfirmBidButtonClick(row, rowIndex);
      });
  };

  renderAuctionBidField = (h) => {

    /*let self = this;

    let allowUp = h.row.CostLoad < h.row.MaxCostLoad;
    let allowDown = h.row.CostLoad > h.row.MinCostLoad;*/
    let allowConfirm = h.row.AllowStake === 1;

    let valueClassName = allowConfirm ? "" : "btn";

    return(
        <div className="" style={{textAlign: "left", border: "none", marginTop: '5px', display: 'flex', flexWrap: 'wrap', width: '100%'}}>
          <span className="btn" style={{color: "green", display:'inline-block'}}>{i18next.t("YourBid")}:</span>
          <div className={valueClassName} style={{display:'inline-block', margin: '0 auto', marginLeft: '0px',
                                                  paddingLeft: '0px', paddingRight: '0px', border: 'none', cursor: 'default',
                                                  width: '30%', minWidth: '100px'}}>
              {
                h.ed(this.auctionFieldSet.bidEditor)
              }
          </div>
          {allowConfirm &&
            <button type="button" className="btn btn-regular btn-carrier-action -goahead" style={{display:'inline-block'}}
                    onClick={() => {this.onConfirmBidButtonClick(h.row, h.rowIndex)}}>
              {i18next.t("ConfirmButton")}
            </button>
          }
          {allowConfirm && this.props.workplaceCountry === workplaceCountries.UKR &&
          <button type="button" className="btn btn-regular btn-carrier-action -goahead"
                  onClick={() => {this.onConfirmPrizeTariffButtonClick(h.row, h.rowIndex)}}>
            {i18next.t("ConfirmPrizeTariffButton")}
          </button>
          }
        </div>

    );
  };

  renderAuctionBidData = (row, rowIndex, fiMap) => {
      let allowStake = row.AllowStake === 1;

      if(!allowStake)
        return null;

      const isRus = this.props.workplaceCountry === workplaceCountries.RUS;
      const isUkr = this.props.workplaceCountry === workplaceCountries.UKR;

      let currentStakeColor = row.GridRowStyle === 15 ? "green" : "red";
      let fontWeight = "bold";

      return (
        <React.Fragment>
          <div className="row fs15" style={{marginTop: "0px"}}>
            <div className="column col-md-12" style={{textAlign: "left"}}>
              <span className="field-title">{fiMap[this.auctionFieldSet.currentBid].Title}:&nbsp;</span>
              <span style={{color: currentStakeColor, fontWeight: fontWeight}}>
                {formatData(fiMap[this.auctionFieldSet.currentBid], row[this.auctionFieldSet.currentBid])}
              </span>
              <span className="field-title" style={{marginLeft: "15px"}}>
                {i18next.t("Step")} - {formatData(fiMap[this.auctionFieldSet.step], row[this.auctionFieldSet.step])}
                {isUkr ? i18next.t("CurrencyGrn") : i18next.t("Currency")}&nbsp;
              </span>
              {isRus &&
              <>
                {row.MaxThreshold > 0
                  ? <React.Fragment>
                    <span className={"zmdi zmdi-long-arrow-up"}/><span>{row.MaxThreshold}%&nbsp;</span>
                  </React.Fragment>
                  : null
                }
                {row.MinThreshold > 0
                  ? <React.Fragment>
                    <span className={"zmdi zmdi-long-arrow-down"}/>{row.MinThreshold}%
                  </React.Fragment>
                  : null
                }
                {row.MinThreshold > 0 || row.MaxThreshold > 0
                  ? <span>&nbsp;{i18next.t("Tariff")}</span> : null
                }
              </>
              }
            </div>
          </div>
          <div className="row fs15">
            <div className="column col-md-12" style={{textAlign: "center", marginTop: "0px", marginBottom: "12px"}}>
              <ComplexParam dataItem={this.props.auctionList}
                            readOnly={false}
                            showSearchBar={false}
                            showApplyButton={false}
                            autoApplyParams={false}
                            rootPath="/"
                            rowIndex={rowIndex}
                            renderParams={this.renderAuctionBidField} />
            </div>
          </div>
        </React.Fragment>
      );
  };

  renderAdditionalRowData = (row, rowIndex, fiMap) => {

    if(!this.state.expandedRows[rowIndex])
      return null;

    const isRus = this.props.workplaceCountry === workplaceCountries.RUS;
    const isUkr = this.props.workplaceCountry === workplaceCountries.UKR;

    return (
        <React.Fragment>
          {isRus &&
          <>
            {this.renderFieldRow(fiMap, row, "ROWeight", formatData(fiMap["ROWeight"], row.ROWeight))}
            {this.renderFieldRow(fiMap, row, "ActionDateTime", formatMnDate(row.ActionDateTime))}
            {this.renderFieldRow(fiMap, row, "LotEndDateTime", formatMnDate(row.LotEndDateTime))}
            {this.renderFieldRow(fiMap, row, "BeginCostLoad", formatData(fiMap["BeginCostLoad"], row.BeginCostLoad))}
            <div className="row fs15">
              <div className="column col-md-12">
                <span className="field-title">{fiMap.CurrentCostLoad.Title}</span>
                <span className={"fs18"}>&nbsp;{
                  row.IsFirstStake === 1
                    ? i18next.t("NoBids")
                    : formatData(fiMap["CurrentCostLoad"], row.CurrentCostLoad)
                }</span>
              </div>
            </div>
            {row.TenderStepMoney &&
            <div className="row fs15">
              <div className="column col-md-12">
                <span className="field-title">{i18next.t("Step")} - </span>
                <span>
                  {formatData(fiMap["TenderStepMoney"], row.TenderStepMoney)}
                  {isUkr ? i18next.t("CurrencyGrn") : i18next.t("Currency")}&nbsp;&nbsp;
                </span>
                {row.MaxThreshold > 0
                  ? <React.Fragment>
                    <span className={"zmdi zmdi-long-arrow-up"}/><span>{row.MaxThreshold}%&nbsp;</span>
                  </React.Fragment>
                  : null
                }
                {row.MinThreshold > 0
                  ? <React.Fragment>
                    <span className={"zmdi zmdi-long-arrow-down"}/>{row.MinThreshold}%
                  </React.Fragment>
                  : null
                }
                {row.MinThreshold > 0 || row.MaxThreshold > 0
                  ? <span>&nbsp;{i18next.t("Tariff")}</span> : null
                }
              </div>
            </div>
            }
          </>
          }

          {isUkr &&
          <>
            {this.renderFieldRow(fiMap, row, "ActionDateTime", formatMnDate(row.ActionDateTime))}
            {this.renderFieldRow(fiMap, row, "CloseDateTime", formatMnDate(row.CloseDateTime))}
            {this.renderFieldRow(fiMap, row, "BeginCostLoad", formatData(fiMap["BeginCostLoad"], row.BeginCostLoad))}
            {this.renderFieldRow(fiMap, row, "CostLoad", formatData(fiMap["CostLoad"], row.CostLoad))}
          </>
          }
        </React.Fragment>
    );
  };

  renderCommandButtons = (row, rowIndex) => {

    let allowAccept = row.AllowAccept === 1;
    let allowRefuse = row.AllowRefuse === 1;
    let allowPrintReport = this.props.workplaceCountry === workplaceCountries.RUS && row.AllowPrintReport === 1;

    return (
      <div className="row fs15">
        <div className="column col-md-12">
          {allowAccept &&
          <button type="button" className="btn btn-regular btn-carrier-action -goahead" onClick={() => {this.onAcceptButtonClick(row, rowIndex)}}>
            {i18next.t("ParticipateButton")}
          </button>
          }
          {allowRefuse &&
          <button type="button" className="btn btn-regular btn-carrier-action" onClick={() => {this.onRefuseButtonClick(row, rowIndex)}}>
            {i18next.t("HideLotButton")}
          </button>
          }
          {allowPrintReport &&
          <button type="button" className="btn btn-regular btn-carrier-action -goescape" onClick={() => {this.onPrintReportButtonClick(row, rowIndex)}}>
            {i18next.t("PrintRequestButton")}
          </button>
          }
        </div>
      </div>
    )
  };

  renderCountdownTimer = (row, rowIndex) => {
    if(row.BeginTimeCurSec <= 0 && row.EndTimeCurSec <= 0)
      return null;

    let timerToStart = row.BeginTimeCurSec > 0;
    let color = timerToStart ? "green" : "red";
    let total = timerToStart ? row.BeginTimeCurSec : row.EndTimeCurSec;
    //let message = timerToStart ? "До начала раунда" : "До конца раунда";
    let message = "";

    total -= this.afterRefreshSeconds;

    let seconds = total % 60;
    total = Math.floor(total / 60);
    let minutes = total % 60;
    total = Math.floor(total / 60);
    let hours = total;

    if(hours < 0)
      hours = 0;

    if(minutes < 0)
      minutes = 0;

    if(seconds < 0)
      seconds = 0;

    return (
      <React.Fragment>
        <span style={{color: color}}>{message}&nbsp;{this.zeroPad(hours, 2)}:{this.zeroPad(minutes, 2)}:{this.zeroPad(seconds, 2)}</span>
      </React.Fragment>
    );
  };

  zeroPad = (num, places) => {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  };

  renderFieldRow = (fiMap, row, name, specialData) => {
    const data = typeof specialData !== 'undefined' ? specialData : row[name];
    return (
      <div className="row fs15">
        <div className="column col-md-12">
          <span className="field-title">{fiMap[name].Title}</span>
          <span>&nbsp;{data}</span>
        </div>
      </div>
    );
  };

  renderRow = (row, rowIndex, renderRowDefault, dataItem) => {

    if (row.HiddenLot === 1)
      return null;

    const isRus = this.props.workplaceCountry === workplaceCountries.RUS;
    const isUkr = this.props.workplaceCountry === workplaceCountries.UKR;

    let docNumber = row.PickupListNumber;
    let docDate = formatMnDate(row.PickupListDate);
    let rowExpanded = this.state.expandedRows[rowIndex];
    let subGridExpanded = this.state.subGridExpandState[rowIndex];
    let expandButtonClass = rowExpanded ? "zmdi zmdi-chevron-up" : "zmdi zmdi-chevron-down";
    let expandSubgridButtonClass = subGridExpanded ? "zmdi zmdi-chevron-up" : "zmdi zmdi-chevron-down";

    let fiMap = {};

    dataItem.rawData.ResultFieldInfo.forEach((item) => {fiMap[item.Name] = item;});

    return (
      <div className="col-md-4" style={{paddingLeft: '0px', paddingRight: '0px'}}>
        <div className="col-md-12">
          <div className="card -cdoc mt10">
            <div className="card-header" style={{paddingBottom: "7px", paddingTop: "7px"}}>
              <div className="row">
                <div className="col-md-12" style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', width: '100%'}}>
                  <h6 style={{display: "inline-block", marginBottom: '0px'}}>
                      {i18next.t("TransportReqCard_CardTitle", {number: docNumber, date: docDate})}
                      {row.MaxThreshold > 0 ? <span className={"zmdi zmdi-long-arrow-up"} style={{color: 'red', fontWeight: 'bold'}}/> : null}
                  </h6>
                  <div style={{textAlign: 'center', display: 'inline-block', margin: '0 auto'}}>
                    {this.renderCountdownTimer(row, rowIndex)}
                  </div>
                  <DocumentStatusImage statusChar={row.CurrentStatus} style={{ marginLeft: '0px', marginRight: "0px", display: "inline-block"}}/>
                  <div style={{display: 'inline-block', marginLeft: '10px'}}>
                    <span className={expandButtonClass}
                          onClick={(e) => this.onRowToggle(rowIndex)}
                          style={{cursor: "pointer"}}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
              <div className="row fs15">
                <div className="col-md-12" style={{
                  backgroundColor: "green",
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%'
                }}>
                  <span style={{ color: "white" }}>{row.SrcCityName} > {row.DstCityName} {row.AutoTypeName} {row.RouteTypeName}</span>

                  <div style={{ margin: "0 auto", marginRight: '0px', display: 'inline-block' }}>
                        <span className="zmdi zmdi-zoom-in" style={{ cursor: "pointer", color: "white", marginRight: "10px", marginLeft: "5px", display: "inline" }}
                              onClick={(e) => this.onShowRouteDetails(rowIndex)}/>
                    <span className={expandSubgridButtonClass} style={{ cursor: "pointer", color: "white", margin: "0 auto", marginRight: '0px', display: 'inline-block' }}
                          onClick={(e) => this.onShowSubGrid(rowIndex)}/>
                  </div>

                </div>
              </div>
              {subGridExpanded && this.renderRouteSubgrid(rowIndex)}
              <div style={{marginTop: "5px"}}>
                {isRus &&
                <>
                  {this.renderFieldRow(fiMap, row, "PlanGrossWeight")}
                  {this.renderFieldRow(fiMap, row, "ReqPlanBeginLoadTime", formatMnDate(row.ReqPlanBeginLoadTime))}
                  {this.renderFieldRow(fiMap, row, "Subject")}
                </>
                }

                {isUkr &&
                <>
                  <div className="row fs15">
                    <div className="column col-md-6">
                      <span className="field-title">{fiMap["GrossWeight"].Title}</span>
                      <span>&nbsp;{row["GrossWeight"]}</span>
                    </div>
                    <div className="column col-md-6">
                      <span className="field-title">{fiMap["RunDistance"].Title}</span>
                      <span>&nbsp;{row["RunDistance"]}</span>
                    </div>
                  </div>
                  <div className="row fs15">
                    <div className="column col-md-6">
                      <span className="field-title">{fiMap["ReqPlanBeginLoadTime"].Title}</span>
                      <span>&nbsp;{formatMnDate(row.ReqPlanBeginLoadTime)}</span>
                    </div>
                    <div className="column col-md-6">
                      <span className="field-title">{fiMap["PlanBeginLoadTime"].Title}</span>
                      <span>&nbsp;{formatMnDate(row.PlanBeginLoadTime)}</span>
                    </div>
                  </div>
                  {this.renderFieldRow(fiMap, row, "Subject")}
                  {this.renderFieldRow(fiMap, row, "BonusPrice", formatData(fiMap["BonusPrice"], row.BonusPrice))}
                  {this.renderFieldRow(fiMap, row, "MaxPrice", formatData(fiMap["MaxPrice"], row.MaxPrice))}
                  {this.renderFieldRow(fiMap, row, "BeginPrice", formatData(fiMap["BeginPrice"], row.BeginPrice))}
                  {this.renderFieldRow(fiMap, row, "CurrentPrice", formatData(fiMap["CurrentPrice"], row.CurrentPrice))}
                  {this.renderFieldRow(fiMap, row, this.auctionFieldSet.step, formatData(fiMap[this.auctionFieldSet.step], row[this.auctionFieldSet.step]))}
                </>
                }

                {this.renderAdditionalRowData(row, rowIndex, fiMap)}
              </div>

              <div className="row fs15" style={{marginTop: "15px", marginBottom: "10px"}}>
                <div className="column col-md-11">
                  {this.renderCommandButtons(row, rowIndex)}
                </div>
              </div>
              {this.renderAuctionBidData(row, rowIndex, fiMap)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSortMenu = () => {

    const sortMenuProvider = new SortMenuProvider(this.props.auctionList);
    let currentSort = this.props.auctionList.getSort();

    return (
      <div className="row">
          <div className="field-title fs16" style={{display: "flex", alignItems: "center", marginLeft: "15px", marginRight: "10px"}}>
            <span style={{display: "flex"}}>{i18next.t('SortbyLabel')}</span>
          </div>
          <div>
            <DropDownMenuComboLink menuAdapter={sortMenuProvider} onSelected={this.sortSelected}/>
          </div>
          {currentSort && currentSort.SortColumn &&
            <div>
              <button className="btn btn-input -link" style={{ marginLeft: "15px" }} onClick={(e) => { e.preventDefault(); this.sortClear(); }}>
                {i18next.t("ResetSorting")}
              </button>
            </div>
          }
      </div>);
  };

  render() {
    if(this.state.isLoading)
      return (<div>{i18next.t("LoadingLabel")}</div>);

    const qs = queryString.stringify({"ShowOnlyNew": 1});
    let trasportInformerLink =  "/" + formObjectToRouteMap["TransportReqList"].link + "?" + qs;
    let auctionInformerLink =  "/" + formObjectToRouteMap["AuctionList"].link + "?" + qs;

    return (
      <React.Fragment>
        <ReportBuildViewer/>
        {this.renderRouteDetailsWindow()}
        <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
          <div className="col-md-8">
            <h1 className="page-title" style={{display: 'inline-block', marginRight: '25px'}}>
              {i18next.t("AuctionListTitle")}
            </h1>
            <button className="btn btn-regular btn-carrier-action -goahead" onClick={this.onRefreshFormClick}>
              {i18next.t("RefreshData")}
            </button>
            {this.props.workplaceCountry === workplaceCountries.RUS && this.props.auctionList.isInitialized &&
            <button className="btn btn-regular btn-carrier-action -goahead" onClick={this.onExportToExcelButtonClick}>
              {i18next.t("ExportToExcel")}
            </button>
            }
          </div>
          <div className="col-md-4" style={{textAlign: "right", paddingRight: "45px"}}>
            {this.state.newTransportRequestCount > 0
              && (trasportInformerLink ?
                 <Link style={{color: "green", fontWeight: 'bold'}}
                       to={trasportInformerLink}>
                   {i18next.t("NewRequirementsCount")}:&nbsp;{this.state.newTransportRequestCount}
                 </Link>
                 : <span style={{color: "green", fontWeight: 'bold'}}>{i18next.t("NewRequirementsCount")}:&nbsp;{this.state.newTransportRequestCount}</span>)
            }
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.newAuctionCount > 0
              && (auctionInformerLink ?
                  <Link style={{color: "green", fontWeight: 'bold'}}
                        to={auctionInformerLink}>
                    {i18next.t("NewAuctionsCount")}:&nbsp;{this.state.newAuctionCount}
                  </Link>
                  : <span style={{color: "green", fontWeight: 'bold'}}>{i18next.t("NewAuctionsCount")}:&nbsp;{this.state.newAuctionCount}</span>)
            }
          </div>
        </div>

        <ComplexParam dataItem={this.props.auctionListParams}
                      readOnly={false}
                      showSearchBar={false}
                      showApplyButton={false}
                      autoApplyParams
                      rootPath="/"
                      parentDataItem={this.props.auctionList}
                      beforeApplyParams={this.onBeforeApplyFormParams}
                      renderParams={this.renderParams} />

        <div className="row">{this.props.auctionList
              && this.props.auctionList.rowsCount() > 0
                ? <span className={"col-md-12"} style={{fontWeight: 'bold'}}>{i18next.t("AllAuctionsCount")}:&nbsp;{this.props.auctionList.rowsCount()}</span>
                : <span>&nbsp;</span>}
        </div>

        <div style={{marginLeft: "-15px", marginRight: "-15px"}}>
          <GridView dataItem={this.props.auctionList}
                    allowPagination
                    activePageSize={12}
                    pageSize={12}
                    renderRow={this.renderRow}
                    showHeader = {false}
                    flexBox
                    flexBoxWidthPercent={100}
                    updateStateFlag={this.state.updateGridFlag}/>
        </div>
      </React.Fragment>
    );
  }
}

class SortMenuProvider {

  constructor(dataItem) {
    this.currentSort = dataItem.getSort();
    this.items = dataItem.getSortableFields().slice()
      .sort((a, b) => (a.Header > b.Header) ? 1 : ((b.Header > a.Header) ? -1 : 0))
      .map(sf => {

        const isActiveColumn = sf.Name === this.currentSort.SortColumn;

        return {
          MenuItemId: sf.Name,
          MenuText: isActiveColumn ? this.getDirSign() + " " + sf.Header : sf.Header,
          IsActive: isActiveColumn,
          SortIsAsc: isActiveColumn ? !this.currentSort.SortIsAsc : true
        }
      });
  }

  getMenuItems() {
    return this.items;
  }

  getVisibleItemsCount() {
    return 1;
  }

  getDropDownText() {
    const i = this.items.find(i => i.MenuItemId === this.currentSort.SortColumn);
    if (i) {
      return i.MenuText + "";
    }

    return "";
  }

  getDirSign() {
    return (!this.currentSort.SortIsAsc ? "↑" : "↓")
  }
}

AuctionList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  workplaceCountry: PropTypes.string,
  auctionBidMode: PropTypes.string
};


AuctionList.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
  const workplaceCountry = state.appState.appParams.workplaceCountry;

  return {
    auctionList: workplaceCountry === workplaceCountries.UKR
      ? state.auctionState.auctionListUA
      : state.auctionState.auctionList,
    auctionListParams: workplaceCountry === workplaceCountries.UKR
      ? state.auctionState.auctionListUAParams
      : state.auctionState.auctionListParams,
    auctionAcceptItem: state.auctionState.auctionAcceptItem,
    auctionRefuseItem: state.auctionState.auctionRefuseItem,
    auctionStakesRefresh: workplaceCountry === workplaceCountries.UKR
      ? state.auctionState.auctionStakesRefreshUA
      : state.auctionState.auctionStakesRefresh,
    auctionInformerItem: state.auctionState.auctionInformerItem,
    routeDetailsItem: state.auctionState.routeDetailsItem,
    workplaceCountry: workplaceCountry,
    auctionBidMode: state.appState.appParams.auctionBidMode
  };
}

export default withRouter(connect(mapStateToProps)(AuctionList));